import { render, staticRenderFns } from "./ProfessionCard.vue?vue&type=template&id=30395cd0&scoped=true&"
import script from "./ProfessionCard.vue?vue&type=script&lang=js&"
export * from "./ProfessionCard.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionCard.vue?vue&type=style&index=0&id=30395cd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30395cd0",
  null
  
)

export default component.exports